import React, { type FC } from 'react';

import { AuthPageLayout } from '../components/AuthPageLayout';
import Page from '../components/page/Page';
import SignupPage from '../components/signup/SignupPage';
import { APPLICANT_SITE_URL } from '../utils/constants';

const CANONICAL_SIGNUP_LINK = `${APPLICANT_SITE_URL}/login`;

const SignUp: FC = () => {
  return (
    <Page noIndex title="Sign Up" canonicalLink={CANONICAL_SIGNUP_LINK}>
      <div>
        <AuthPageLayout>
          <SignupPage />
        </AuthPageLayout>
      </div>
    </Page>
  );
};

export default SignUp;
